/* Version: 2026-10-26 performance patch; Created: unknown; Updated: 2026-10-26. Changelog: defer offscreen work; preserve native cards and purchase flow. */
/* ROCKBROS NL homepage collection activity – UK layout + single scroller sync; concatenated without logic changes. */
/* NL 10.12 UK activity flow.
   One mobile product panel after its activity tile; native horizontal scroller.
   No duplicate black progress rail and no per-scroll script work. */
(()=>{'use strict';
if(window.__rbnlUKActivityV4)return;window.__rbnlUKActivityV4=true;
const bp=matchMedia('(max-width:768.98px)');
const selector='[data-rbnl-campaign="true"][data-rbnl-mobile-tiles="uk_stacked"]';
const warmed=new WeakSet();
const rootItems=()=>[...document.querySelectorAll(selector)];
function sync(){
 rootItems().forEach(root=>{
  const grid=root.querySelector('.rb-home-collection-collage__grid');
  const host=root.querySelector('[data-rbnl-panels]');
  if(!grid||!host)return;
  const tiles=[...root.querySelectorAll('[data-rbnl-tile]')];
  const panels=[...root.querySelectorAll('[data-rbnl-panel]')];
  const panelById=new Map(panels.map(p=>[p.dataset.rbnlPanel,p]));
  const slots=new Map([...root.querySelectorAll('[data-rbnl-panel-slot]')].map(p=>[p.dataset.rbnlPanelSlot,p]));
  tiles.forEach(tile=>{
   const panel=panelById.get(tile.dataset.rbnlTile);
   if(!panel)return;
   let slot=slots.get(tile.dataset.rbnlTile);
   if(bp.matches){
    if(!slot){
     slot=document.createElement('li');
     slot.className='rbnl-campaign__panel-slot';
     slot.dataset.rbnlPanelSlot=tile.dataset.rbnlTile;
     slots.set(tile.dataset.rbnlTile,slot);
    }
    if(slot.parentElement!==grid||slot.previousElementSibling!==tile)tile.insertAdjacentElement('afterend',slot);
    if(panel.parentElement!==slot)slot.append(panel);
    slot.hidden=panel.hidden;
   }else{
    if(panel.parentElement!==host)host.append(panel);
    slot?.remove();
   }
  });
 });
}
function prepareOffscreenPanels(root){
 if(warmed.has(root))return;warmed.add(root);
 const queue=[...root.querySelectorAll('[data-rbnl-lazy-products]:not([data-rbnl-remote-section])')];
 if(!queue.length)return;
 const idle=fn=>window.requestIdleCallback?requestIdleCallback(fn):setTimeout(fn,350);
 const fill=()=>{
  const template=queue.shift();
  if(template?.isConnected){
   const list=template.closest('[data-rbnl-panel]')?.querySelector('.rbnl-campaign__products');
   if(list){list.append(template.content.cloneNode(true));template.remove()}
  }
  if(queue.length)idle(fill);
 };
 idle(fill);
}
let watcher=null;
function scheduleWarm(){
 if(!('IntersectionObserver' in window)){rootItems().forEach(prepareOffscreenPanels);return}
 if(!watcher)watcher=new IntersectionObserver(entries=>{
  for(const e of entries)if(e.isIntersecting){watcher.unobserve(e.target);prepareOffscreenPanels(e.target)}
 },{rootMargin:'750px 0px'});
 rootItems().forEach(root=>{if(!warmed.has(root))watcher.observe(root)});
}
function init(){sync();scheduleWarm()}
document.addEventListener('click',e=>{
 const el=e.target instanceof Element?e.target:null;
 const btn=el?.closest('[data-rbnl-slide-step]');
 if(!btn)return;
 const root=btn.closest(selector);
 const track=btn.closest('[data-rbnl-panel]')?.querySelector('.rbnl-campaign__products');
 if(!root||!track)return;
 e.preventDefault();
 const direction=Number(btn.dataset.rbnlSlideStep);
 if(!Number.isFinite(direction)||direction===0)return;
 track.scrollBy({left:direction*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
bp.addEventListener?.('change',sync);
document.addEventListener('shopify:section:load',init);
})();
;
/* ROCKBROS NL 10.12: single native-style scroll progress for collection panels.
   No cart, preview or product-card interaction is overwritten. */
(()=>{'use strict';
if(window.__rbnlHomepageV9)return;window.__rbnlHomepageV9=true;
const selector='[data-rbnl-campaign="true"]';
let queued=new Set(),frame=0;
function update(panel){
  if(!panel)return;
  const list=panel.querySelector('.rbnl-campaign__products');
  const track=panel.querySelector('[data-rbnl-track]');
  if(!list||!track)return;
  const visible=list.clientWidth;
  const total=list.scrollWidth;
  const overflow=Math.max(0,total-visible);
  track.hidden=!visible||overflow<3;
  const controls=panel.querySelectorAll('[data-rbnl-slide-step]');
  controls.forEach(btn=>{
    const step=Number(btn.dataset.rbnlSlideStep);
    if(Number.isFinite(step))btn.disabled=!visible||overflow<3||(step<0?list.scrollLeft<=2:list.scrollLeft>=overflow-2);
  });
  if(track.hidden)return;
  const fraction=Math.max(12,Math.min(100,(visible/total)*100));
  const position=overflow?Math.max(0,Math.min(100-fraction,(list.scrollLeft/overflow)*(100-fraction))):0;
  track.style.setProperty('--rbnl-track-width',fraction+'%');
  track.style.setProperty('--rbnl-track-left',position+'%');
}
function schedule(panel){
  if(!panel)return;queued.add(panel);
  if(frame)return;
  frame=requestAnimationFrame(()=>{frame=0;for(const p of queued)update(p);queued.clear()});
}
const watched=new WeakSet();
let listObserver=null;
function attach(root){
  if(!root||watched.has(root))return;watched.add(root);
  const observer=new MutationObserver(changes=>{
    const panels=new Set();
    for(const c of changes){
      const p=c.target instanceof Element?c.target.closest('[data-rbnl-panel]'):null;
      if(p)panels.add(p);
    }
    for(const p of panels)schedule(p);
  });
  observer.observe(root,{childList:true,subtree:true});
  root.querySelectorAll('[data-rbnl-panel]').forEach(schedule);
}
function init(){document.querySelectorAll(selector).forEach(attach)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',e=>{const root=e.target.querySelector?.(selector)||e.target.closest?.(selector);if(root)attach(root)});
document.addEventListener('scroll',e=>{
  const target=e.target;
  if(target instanceof Element&&target.matches('[data-rbnl-campaign="true"] .rbnl-campaign__products'))schedule(target.closest('[data-rbnl-panel]'));
},true);
document.addEventListener('click',e=>{
  const el=e.target instanceof Element?e.target:null;
  if(!el)return;
  const panel=el.closest('[data-rbnl-panel]');
  if(panel&&el.closest('[data-rbnl-slide-step]'))requestAnimationFrame(()=>schedule(panel));
  const tile=el.closest('[data-rbnl-tile]');
  if(tile&&tile.closest('[data-rbnl-campaign="true"]')&&!el.closest('[data-rbnl-cta-link]')){
    const root=tile.closest('[data-rbnl-campaign="true"]');
    requestAnimationFrame(()=>root.querySelectorAll('[data-rbnl-panel]').forEach(schedule));
  }
},true);
window.addEventListener('resize',()=>document.querySelectorAll(selector+' [data-rbnl-panel]').forEach(schedule),{passive:true});
})();
